import { Controller } from "@hotwired/stimulus"

// Automatische Maschinenstunden card on a vehicle's settings (fleets/geofence_bookings/_card):
// the hour and minimum fields only matter once a mode is chosen, the hours only in "fixed".
// Hidden, not removed — the saved values come back when the mode does.
export default class extends Controller {
  static targets = ["mode", "details", "fixed", "hours"]

  connect() {
    this.modeChanged()
  }

  modeChanged() {
    const mode = this.selectedMode()
    this.detailsTarget.hidden = mode === "off"
    this.fixedTarget.hidden = mode !== "fixed"
  }

  presetHours({ params: { hours } }) {
    this.hoursTarget.value = hours
  }

  selectedMode() {
    return this.modeTargets.find((input) => input.checked)?.value ?? "off"
  }
}
